/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import './YearFilterCard.css';
import { themes, fonts } from '../../themes/themes';
import YearFilterButton from '../YearFilterButton/YearFilterButton';
interface IYearFilterCardProps {
  card_title?: string;
  card_height?: string;
  height?: string;
  yearTitle: any;
  yearMenu: any;
  filterhead?: any;
  onYearSelect: (data: any) => void;
  leaveType?: string;
  onfilterhead?: (data: any) => void;
}

const YearFilterCard: React.FC<
  React.PropsWithChildren<IYearFilterCardProps>
> = ({
  children,
  card_title,
  card_height,
  yearMenu,
  yearTitle,
  leaveType,
  filterhead,
  height,
  onYearSelect,
  onfilterhead,
}) => {
  return (
    <Box
      className="only_year_filter_card"
      style={{
        maxHeight: card_height,
        height: height ?? 'auto',
      }}
    >
      <Grid container>
        <Grid
          item
          xs={12}
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <Grid
            item
            xs={4}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
            }}
          >
            <Typography
              style={{
                color: themes.blackDefault,
                fontSize: fonts.header,
                fontFamily: fonts.fontFamily,
                fontWeight: 'bold',
                display: 'inline-block',
              }}
            >
              {' '}
              {card_title}
            </Typography>
          </Grid>
          {filterhead && onfilterhead ? (
            <Grid
              item
              xs={6}
              style={{
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'flex-end',
              }}
            >
              <YearFilterButton
                menu={filterhead}
                onSelect={onfilterhead}
                title={leaveType}
              />
            </Grid>
          ) : (
            ''
          )}
          <Grid
            item
            xs={6}
            style={{
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'flex-end',
            }}
          >
            <YearFilterButton
              menu={yearMenu}
              onSelect={onYearSelect}
              title={yearTitle}
            />
          </Grid>
        </Grid>
      </Grid>
      <Box
        style={{
          marginTop: '0.5em',
          paddingBottom: '5px',
          overflowY: 'auto',
          height: 'auto',
          maxHeight: '600px',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default YearFilterCard;
